/**
 * Cookie de afiliação (sponsor / upline) — define o cliente recomendador a
 * usar quando o utilizador se regista. É persistido por 6 meses para
 * cobrir o caso de o visitante chegar via link de afiliado e só voltar
 * mais tarde para criar conta.
 *
 * Captura via:
 *   - `?REFER=12345` no URL (case-insensitive)
 *   - `?refer=12345`
 *
 * Pode ser limpo após registo bem-sucedido para evitar "carry-over" ao
 * próximo registo na mesma máquina (caso seja um device partilhado).
 */
const COOKIE_NAME = "REFER";
// Janela de 6 meses (aumentada de 30 dias em 2026-07): o visitante pode
// chegar via link de afiliado, ponderar durante semanas ou meses e só
// depois regressar para criar conta — o sponsor tem de continuar
// associado durante todo esse período.
const MAX_AGE_DAYS = 180;

export function captureReferFromUrl() {
  try {
    const url = new URL(window.location.href);
    const raw = url.searchParams.get("REFER")
      || url.searchParams.get("refer")
      || url.searchParams.get("Refer");
    if (!raw) return null;
    const id = parseInt(raw, 10);
    if (!Number.isInteger(id) || id <= 0) return null;
    setReferCookie(id);
    return id;
  } catch (e) {
    if (process.env.NODE_ENV !== "production") console.warn("captureReferFromUrl failed:", e);
    return null;
  }
}

export function getReferCookie() {
  try {
    const m = document.cookie.match(new RegExp("(^|;\\s*)" + COOKIE_NAME + "=([^;]+)"));
    if (!m) return null;
    const id = parseInt(decodeURIComponent(m[2]), 10);
    return Number.isInteger(id) && id > 0 ? id : null;
  } catch {
    return null;
  }
}

export function setReferCookie(id) {
  const maxAge = MAX_AGE_DAYS * 24 * 60 * 60;
  // O cookie é lido pelo backend em qualquer subdomínio do site IHTP — usa
  // domain=.ihavethepower.net em produção. O navegador ignora silenciosamente
  // se o domínio não corresponder (caso preview *.emergentagent.com), pelo
  // que setamos também sem domain explícito como fallback.
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(id)}; path=/; max-age=${maxAge}; SameSite=Lax`;
  if (window.location.hostname.endsWith("ihavethepower.net")) {
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(id)}; path=/; max-age=${maxAge}; SameSite=Lax; domain=.ihavethepower.net`;
  }
}

export function clearReferCookie() {
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax`;
  if (window.location.hostname.endsWith("ihavethepower.net")) {
    document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax; domain=.ihavethepower.net`;
  }
}
